<template>
    <ion-item button :detail="false" :disabled="disabled" @click="openSelectModal()" lines="inset"
        class="ion-activatable ripple-parent">
        <ion-label position="stacked">{{ label }} </ion-label>
        <span style="text-overflow: ellipsis" class="my-2">{{ selected }}</span>
        <ion-icon size="small" color="primary" class="edit-icon" :icon="createOutline"></ion-icon>
        <ion-ripple-effect></ion-ripple-effect>
    </ion-item>
</template>

<script>
import SelectModal from './SelectModal.vue';
import {
    modalController
} from '@ionic/vue';
import { createOutline } from 'ionicons/icons';

export default {
    name: 'novacheck-row',
    props: ['items', 'label', 'value', 'field_name', 'field_value', 'disabled', 'showCreateButton', 'fullscreen', 'location_item_uuid'],
    data() {
        return {
            createOutline,
            current_selected: null
        }
    },
    methods: {
        setDefault() {
            //  if we only have 1 item, set it as default
            if (this.items.length == 1) {
                this.current_selected = this.items[0][this.field_value]
            }
        },
        async openSelectModal() {
            const modal = await modalController.create({
                component: SelectModal,
                componentProps: {
                    items: this.items,
                    label: this.label,
                    field_name: this.field_name,
                    showCreateButton: this.showCreateButton,
                    location_item_uuid: this.location_item_uuid,
                },
                initialBreakpoint: 1,
                breakpoints: [0.50, 1]
            }
            );
            modal.present();

            const { data, role } = await modal.onWillDismiss();

            if (role == 'confirm') {
                if (this.field_value) {
                    this.current_selected = data[this.field_value];
                }
            }

            if (role == 'create') {
                this.$emit('refresh');
            }
        },
    },
    computed: {
        selected() {
            let selected = this.items.find(item => item[this.field_value] == this.current_selected)
            if (selected) {
                return selected.name
            }

            return '-'
        }
    },
    watch: {
        items: {
            handler() {
                this.setDefault()
            },
            immediate: true
        },
        value: {
            handler() {
                this.current_selected = this.value
            },
            immediate: true,
            deep: true
        },
        current_selected(newValue) {
            this.$emit('change', newValue);
            this.$emit('update:value', newValue)
        }
    }
}
</script>

<style>
.edit-icon {
    position: absolute;
    right: 15px;
    margin-top: 20px;
}
</style>
